type Context = 'integration';

type IntegrationType = 'pipedrive';

type Section = 'owners' | 'owner-mappings' | 'fbl-fields' | 'fields' | 'field-mappings' | 'settings';

type Value = `${Context}-${IntegrationType}-${Section}`;

export const Keys: Record<Section, Value> = {
  owners: 'integration-pipedrive-owners',
  'owner-mappings': 'integration-pipedrive-owner-mappings',
  'fbl-fields': 'integration-pipedrive-fbl-fields',
  fields: 'integration-pipedrive-fields',
  'field-mappings': 'integration-pipedrive-field-mappings',
  settings: 'integration-pipedrive-settings',
};
